export const SPEED_OPTIONS = [
    {value: 'VERY_SLOW', label: 'Very Slow', coefficient: 1.50},
    {value: 'SLOW', label: 'Slow', coefficient: 1.25},
    {value: 'NORMAL', label: 'Normal', coefficient: 1.00},
    {value: 'FAST', label: 'Fast', coefficient: 0.80},
    {value: 'VERY_FAST', label: 'Very Fast', coefficient: 0.67},
];

export const WEEK_DAYS = [
    'MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY', 'SATURDAY', 'SUNDAY'
];

export const DAY_LABELS = {
    MONDAY: 'Monday', TUESDAY: 'Tuesday', WEDNESDAY: 'Wednesday', THURSDAY: 'Thursday',
    FRIDAY: 'Friday', SATURDAY: 'Saturday', SUNDAY: 'Sunday',
};

function defaultPreference(source) {
    return {source, address: null};
}

export function createDefaultWorkerProfile() {
    return {
        speed_tier: 'NORMAL',
        time_coefficient: 1,
        active: true,
        home_address: null,
        default_start_address: defaultPreference('HOME'),
        default_end_address: defaultPreference('HOME'),
        working_hours: WEEK_DAYS.map(day => ({
            day_of_week: day,
            enabled: true,
            start_time: '09:00',
            end_time: '17:00',
            start_address: defaultPreference('DEFAULT'),
            end_address: defaultPreference('DEFAULT'),
        })),
        skill_ids: [],
        service_areas: [],
    };
}

export function normalizeWorkerProfile(profile) {
    const defaults = createDefaultWorkerProfile();
    if (!profile) return defaults;
    const days = new Map((profile.working_hours || []).map(day => [day.day_of_week, day]));
    return {
        ...defaults,
        ...profile,
        default_start_address: {...defaults.default_start_address, ...profile.default_start_address},
        default_end_address: {...defaults.default_end_address, ...profile.default_end_address},
        working_hours: defaults.working_hours.map(day => ({
            ...day,
            ...(days.get(day.day_of_week) || {}),
            start_address: {...day.start_address, ...(days.get(day.day_of_week)?.start_address || {})},
            end_address: {...day.end_address, ...(days.get(day.day_of_week)?.end_address || {})},
        })),
        skill_ids: profile.skill_ids || [],
        service_areas: profile.service_areas || [],
    };
}

export function speedOption(speedTier) {
    return SPEED_OPTIONS.find(option => option.value === speedTier) || SPEED_OPTIONS[2];
}
